import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import _ from "lodash";
import TextareaCounter from '../../FormComponents/TextareaCounter';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { NavLink, Prompt } from 'react-router-dom';
import utils from '../../../lib/utils';

import './index.scss';

import Loading from '../../common/Loading';
import helper from '../../Conversations/helpers';

const special = ['zeroth', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth'];
const deca = ['twent', 'thirt', 'fort', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];

const dropdownCustomStyle = {
  control: base => ({
    ...base,
    border: '1px solid #CFD0D1',
    // This line disable the blue border
    padding: '6px 12px',
    boxShadow: 'none',
    outLine: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    }
  }),
  option: base => ({
    ...base,
    padding: '8px 15px',
  }),
  placeholder: base => ({
    ...base,
    color: '#4A4A4A'
  }),
  indicatorsContainer: base => ({
    ...base,
    color: '#4A4A4A'
  }),
  valueContainer: base => ({
    ...base,
    padding: '2px',
    color: '#4A4A4A'
  }),
};
const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <i className="material-icons custom">arrow_drop_down</i>
      </components.DropdownIndicator>
    )
  );
};


class AddCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.startRef = React.createRef();
    this.endRef = React.createRef();
    this.state = {
      name: '',
      service: undefined,
      source: '',
      first_message:
        'Hi ' +
        this.getClientName() +
        '! It’s Sasha from ' +
        this.getBusinessName() +
        '. Thanks for your interest in our promo.',
      pricing_message: '',
      sucess: true,
      copied: false,
      promo_code: '',
      reminder_counts: [
        { key: 0, value: 0 },
        { key: 1, value: 1 },
        { key: 2, value: 2 }
      ],
      reminder_interval_range: 15,
      follow_up_count: 0,
      follow_ups: [],
      startDate: new Date(),
      endDate: undefined,
      editmode: false,
      editname: false,
      allowedit: true,
      readytosend: false,
      goBackWithoutSave: false,
      campaignType: this.props.formresponse.campaignType
    };
  }

  getMessageReminder = (index) => {
    console.log('getMessageReminder', index)
    const { reminder_interval_range } = this.state;
    let reminder = [];
    for (let i = 0; i < reminder_interval_range; i++) {
      if (index === 1) {
        reminder.push({ key: `P${i + 1}D`, value: `${i + 1} days after the First Message`, reminder_index: i + 1, interval_days: i + 1 },);
      } else {
        reminder.push({ key: `P${i + 1}D`, value: `${i + 1} days after the Follow Up 1 `, reminder_index: i + 1, interval_days: i + 1 },);
      }
    }
    return reminder;
  }
  copyCodeToClipboard = () => {
    // const el = this.textArea
    // el.select()
    // document.execCommand("copy")
    // this.setState({
    //   copied:true
    // })
    this.props.webhookCopy(this.props.formresponse.form);
  };
  getBusinessName = () => {
    if (this.props.business.info.BUSINESS_NAME) {
      return this.props.business.info.BUSINESS_NAME;
    } else {
      return '<business name>';
    }
  };
  getClientName = () => {
    // if(this.props.business.info.FIRST_NAME){
    //   return this.props.business.info.FIRST_NAME+' '+this.props.business.info.LAST_NAME;
    // }else{
    return '<NAME>';
    //}
  };
  getPromoServiceName = () => {
    if (this.getServiceName(this.state.service)) {
      return this.getServiceName(this.state.service);
    } else {
      return '<promo service>';
    }
  };
  closeModal() {
    this.setState({
      goBackWithoutSave: false
    })
  }
  addCampaign = () => {
    const { business, auth } = this.props;
    const business_id = business.id || auth.studio_id;
    let params = {};
    if (!this.state.editmode) {
      params = {
        name: this.state.name,
        service_name: this.getServiceName(this.state.service),
        service_id: this.state.service,
        source: this.state.source,
        first_message: this.state.first_message,
        pricing_message: this.state.pricing_message,
        campaign_start: this.state.startDate,
        promo_code: this.state.promo_code,
        follow_up_count: this.state.follow_up_count,
        follow_ups: this.state.follow_ups,
        campaign_type: this.state.campaignType,
        businessId: business_id,
        ...(this.state.startDate && { campaign_expiry: this.state.endDate }),
      };
      this.props.postForm(params);
    } else {
      params = {
        ...this.props.formresponse.details,
        follow_ups: this.state.follow_ups,
        first_message: this.state.first_message,
        pricing_message: this.state.pricing_message,
        campaign_type: this.state.campaignType,
        businessId: business_id,
      }
      this.props.putForm(params);
    }

    console.log('Params', params);

    this.props.history.goBack();
  };
  componentDidMount = () => {
    const { match: { params }, formresponse } = this.props;
    console.log('params', params, formresponse);
    if (params.id) {
      this.props.getCampaign({ id: params.id, year_month: formresponse.formresponse.year_month })
      this.setState({
        editmode: true
      })
    } else {
      this.setState({
        name: this.props.formresponse.leadName,
      })
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.formresponse && nextProps.formresponse.leadName && this.props.formresponse.leadName != nextProps.formresponse.leadName) {
      this.setState({
        name: nextProps.formresponse.leadName
      })
    }
    if (nextProps.formresponse && nextProps.formresponse.postDetails === false && nextProps.formresponse.postDetails !== this.props.formresponse.postDetails) {
      console.log('Update Fields', nextProps.formresponse.details);
      const { campaign_expiry,
        campaign_start,
        first_message,
        pricing_message,
        follow_ups,
        name,
        promo_code,
        service_id, follow_up_count, campaign_type } = nextProps.formresponse.details;
      const { info } = nextProps.business
      this.setState({
        endDate: new Date(moment(campaign_expiry).tz(info.TIMEZONE).format()),
        startDate: new Date(moment(campaign_start).tz(info.TIMEZONE).format()),
        first_message,
        pricing_message,
        follow_ups: this.convertFollowptoDays(follow_ups) || [],
        name,
        promo_code,
        service: service_id,
        follow_up_count: follow_up_count || 0,
        campaign_type
      })
    }
  }

  convertFollowptoDays = (follow_ups) => {
    return follow_ups.map(item => {
      const duration = moment.duration(item.interval);
      const days = duration.asDays();

      return {
        ...item,
        interval_days: days
      };
    });
  }

  getServiceName = (service_id) => {
    if (this.props.formresponse && this.props.formresponse.servicelist) {
      return this.props.formresponse.servicelist.filter(s => s.service_id == service_id).map(s => s.service_name)[0];
    } else {
      return undefined;
    }
  };
  handleChange = (event, target) => {
    this.setState({
      [target]: event.target.value,
      ...(target === 'follow_up_count' && { follow_ups: this.generateFollowup(event.target.value) })
    });
    if (target === 'service') {
      this.setState({
        first_message:
          'Hi ' +
          this.getClientName() +
          '! It’s Sasha from ' +
          this.getBusinessName() +
          '. Thanks for your interest in our ' +
          this.getServiceName(event.target.value) +
          ' promo.',
      });
    }
  };

  handleChangeDate = (date, type) => {
    this.setState({
      [type]: date,
    });
  };

  disableAddCampaign = () => {
    const { name, first_message, pricing_message, service, source, startDate } = this.state;
    const { formresponse } = this.props;
    if (
      name.trim().length > 0 &&
      first_message.trim().length > 0 &&
      source.trim().length > 0 &&
      startDate &&
      !formresponse.postForm
    ) {
      if (
        this.props.formresponse &&
        this.props.formresponse.servicelist &&
        !this.isEmpty(this.props.formresponse.servicelist)
      ) {
        return service ? false : true;
      }
    } else {
      return true;
    }
  };

  isEmpty = (obj) => {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  };
  datePickerVisible = (event, ref) => {
    const node = ref.current;
    node.setFocus();
  };

  getDescriptiontoCreate = (domain) => {
    if (domain === 'DENTAL') {
      return "Lead Engage engages prospective patients after they submit a form showing interest in a service promotion campaign and books them for the service. To setup Lead Engage for a particular service campaign, let's start by telling TrueLark about the promotion.";
    } else {
      return "Lead Engage engages clients after they submit a form showing interest in a service promotion campaign and books them for the service. To setup Lead Engage for a particular service campaign, let's start by telling TrueLark about the promotion.";
    }
  };

  getCreateSucessMessage = (domain) => {
    if (domain === 'DENTAL') {
      return 'The next step is to configure your marketing lead platform to send data to TrueLark Lead Engage so that TrueLark can receive the necessary prospect contact information and start following up.';
    } else {
      return 'Next, you need to setup TrueLark integration externally on your marketing platform in order for TrueLark to start responding and getting data.';
    }
  };

  getWebhookLabel = (domain) => {
    if (domain === 'DENTAL') {
      return 'Below is the unique webhook URL for this campaign.';
    } else {
      return 'Below is your unique url that you should use as a webhook.';
    }
  };

  sendAbled = () => {
    const { first_message, pricing_message, nameerror, follow_ups } = this.state;
    if (first_message.trim().length > 0 && !nameerror) {
      let followupcheck = follow_ups.filter(followup => {
        return followup.message.trim().length === 0;
      });
      if (followupcheck.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  saveAndExit = () => {
    this.setState({
      goBackWithoutSave: true
    })
  }
  nameChange = (event) => {
    if (event.target.value.trim().length > 0) {
      this.setState({ name: event.target.value, error: false, nameerror: false })
    } else {
      this.setState({ name: event.target.value, nameerror: true })
    }
  }

  editName = () => {
    if (this.state.allowedit) {
      setTimeout(() => { document.getElementById('name-input').focus(); }, 100)
      this.setState({ editname: true }
      );
    }
  }
  removeFocus = () => {
    this.setState({ editname: false }
    );
  }

  handleFollowUp = (event, target, index_to_change) => {
    let follow_ups = [...this.state.follow_ups];
    follow_ups.map(follow => {
      if (follow.follow_up_index === index_to_change) {
        if (target === 'interval') {
          follow[target] = `P${event.target.value}D`;
        } else {
          follow[target] = event.target.value;
        }
      }
    })
    console.log('follo up', follow_ups);
    this.setState({
      follow_ups
    })
  }

  generateFollowup = (count) => {
    let follow_ups = [...this.state.follow_ups];
    if (count !== follow_ups.length) {
      let diff = count - follow_ups.length;
      let current_index = follow_ups.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          follow_ups.push({
            follow_up_index: current_index + i + 1,
            message: 'Hi ' +
              this.getClientName() +
              '! It’s Sasha from ' +
              this.getBusinessName() +
              '. Thanks for your interest in our promo.',
            interval: 'P1D'
          });
        }
      } else {
        for (let i = diff; i < 0; i++) {
          follow_ups.pop();
        }
      }
    }
    return follow_ups;
  }
  autoresizeInputField = () => {
    const { name } = this.state;
    let fieldlength = name ? (name.length + 4) * 16 : 16;
    return fieldlength;
  }

  stringifyNumber = (n) => {
    if (n < 20) return special[n];
    if (n % 10 === 0) return deca[Math.floor(n / 10) - 2] + 'ieth';
    return deca[Math.floor(n / 10) - 2] + 'y-' + special[n % 10];
  }

  render() {
    const { modelopen, formresponse, auth } = this.props;
    const { promo_code, service, reminder_counts, goBackWithoutSave, campaign_type } = this.state;
    const { openFileModal, first_message, pricing_message, editmode, name, editname, follow_ups, follow_up_count, allowedit, errormessage, error } = this.state;
    const { leadName, campaignType } = formresponse;
    const type_of_campaign = campaign_type ? campaign_type : campaignType;
    const features = utils.getCookie('feature')
    console.log('formresponse', formresponse);
    console.log('follow_ups', follow_ups);
    return (
      <div className="add-campaign">
        {(formresponse.postForm === true || formresponse.postDetails === true) &&
          <div className="add-campaign_loader">
            <Loading />
          </div>
        }
        {((editmode && (formresponse.postForm !== true && formresponse.postDetails !== true)) || !editmode) &&
          <div className='add-campaign_title'>
            <div className="add-campaign_title_content">
              <div className="title" onClick={this.saveAndExit}>
                <span className="material-icons">arrow_back</span>
                <span className="back-text">Go back</span>
              </div>
            </div>
            <div className="add-campaign_title_meta">
              <div className="name" >
                <input id="name-input"
                  className={classnames('input-name', { 'focus-input': this.state.editname })}
                  onBlur={this.removeFocus} value={name} onChange={this.nameChange}
                  disabled={!editname || editmode}
                  minLength="1" maxLength="100"
                  style={{ width: +this.autoresizeInputField() + 'px' }}
                />
                {!editmode && <i disabled={editmode} onClick={this.editName} class="material-icons">edit</i>}</div>
              <div className="actions hide-in-mobile">
                <button disabled={this.sendAbled()} className="send" style={{ opacity: (this.sendAbled() ? 0.5 : 1) }} onClick={this.addCampaign}> {editmode ? 'UPDATE' : 'Publish'}</button>
              </div>
            </div>
            {((editmode && formresponse.postForm !== true) || !editmode) &&
              <div className="add-campaign_campaign">
                <div className="add-campaign_campaign_content">
                  <div className="message">
                    <div className="title">Campaign Details</div>
                    <div className="form-container">
                      {!this.isEmpty(formresponse.servicelist) && (
                        <div className="input-container">
                          {type_of_campaign && type_of_campaign === 'CLASS' ?
                            (<label className="label">
                              CLASSES (OPTIONAL)
                            </label>) : (
                              <label className="label">
                                APPOINTMENT (OPTIONAL)
                              </label>)
                          }
                          {/* <div className="select-container">
                            <select onChange={(e) => this.handleChange(e, 'service')} value={service} disabled={editmode} className={classnames({ 'disabled-input': editmode })}>
                              {type_of_campaign && type_of_campaign === 'CLASS' ? (<option value="">Select a class</option>) : (<option value="">Select a appointment</option>)}
                              {formresponse.servicelist.filter(s => s.service_type == type_of_campaign).sort((a, b) => {
                                const nameA = (a.service_name || "").toString(); // Ensure it's a string
                                const nameB = (b.service_name || "").toString(); // Ensure it's a string
                                return nameA.localeCompare(nameB);
                              }).map(function (service) {
                                return (
                                  <option value={service.service_id}>
                                    {service.service_name}
                                  </option>
                                );
                              })
                              }
                            </select>
                            <i className="material-icons">arrow_drop_down</i>
                          </div> */}
                          <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            placeholder={type_of_campaign && type_of_campaign === 'CLASS' ? 'Select a class' :'Select a appointment'}
                            isSearchable={true}
                            value={formresponse.servicelist.filter(s => s.service_type == type_of_campaign).filter((option) => option.service_id === service,)}
                            getOptionLabel={(option) => option.service_name}
                            getOptionValue={(option) => option.service_id}
                            options={_.sortBy(formresponse.servicelist.filter(s => s.service_type == type_of_campaign), ['service_name'])}
                            noOptionsMessage={() => null}
                            isDisabled={editmode}
                            onChange={(event) => {
                              this.handleChange({ target: { value: event.service_id } }, 'service');
                            }}
                            styles={dropdownCustomStyle}
                          />
                          {type_of_campaign && type_of_campaign === 'CLASS' ? (<div className="disclaimer">
                            * If you do not select a specific class, TrueLark will book any class the guest requests.
                          </div>) :
                            (<div className="disclaimer">
                              * If you do not select a specific appointment, TrueLark will book any service the guest requests.
                            </div>)}
                        </div>
                      )}
                      {type_of_campaign && type_of_campaign === 'SESSION' &&
                        <div className="input-container">
                          <label className="label">
                            PROMO CODE (OPTIONAL)
                          </label>
                          <div className="select-container">
                            <input type="text" placeholder="Enter promo code" value={promo_code} onChange={(e) => this.handleChange(e, 'promo_code')} disabled={editmode} className={classnames({ 'disabled-input': editmode })} />
                          </div>
                          <div className="disclaimer">
                            * Promo code will get added to the appointment note.
                          </div>
                        </div>}
                      <div className="input-date">
                        <div className="input-date_holder">
                          <div className="input-container">
                            <label className="label">Booking Start Date *</label>
                            <div className={classnames('custom-date-picker', { 'disabled-input': editmode })}>
                              <i
                                class="far fa-calendar-alt"
                                onClick={(e) =>
                                  this.datePickerVisible(e, this.startRef)
                                }
                              />
                              {this.state.endDate ? (
                                <DatePicker
                                  ref={this.startRef}
                                  selected={this.state.startDate}
                                  onChange={(date) =>
                                    this.handleChangeDate(date, 'startDate')
                                  }
                                  dateFormat="MMMM d, yyyy"
                                  placeholderText="Select Date"
                                  minDate={new Date()}
                                  maxDate={new Date(moment(this.state.endDate))}
                                  disabled={editmode}
                                  className={classnames({ 'disabled-input': editmode })}
                                />
                              ) : (
                                <DatePicker
                                  ref={this.startRef}
                                  selected={this.state.startDate}
                                  onChange={(date) =>
                                    this.handleChangeDate(date, 'startDate')
                                  }
                                  dateFormat="MMMM d, yyyy"
                                  placeholderText="Select Date"
                                  minDate={new Date()}
                                  disabled={editmode}

                                />
                              )}
                            </div>
                          </div>
                          <div className="input-container">
                            <label className="label">
                              Booking End Date <span>(OPTIONAL)</span>
                            </label>
                            <div className={classnames('custom-date-picker', { 'disabled-input': editmode })}>
                              <i
                                class="far fa-calendar-alt"
                                onClick={(e) =>
                                  this.datePickerVisible(e, this.endRef)
                                }
                              />
                              <DatePicker
                                ref={this.endRef}
                                selected={this.state.endDate}
                                onChange={(date) =>
                                  this.handleChangeDate(date, 'endDate')
                                }
                                dateFormat="MMMM d, yyyy"
                                placeholderText="Select Date"
                                minDate={new Date(moment(this.state.startDate))}
                                disabled={editmode}
                                className={classnames({ 'disabled-input': editmode })}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="disclaimer">
                          *Availabilities will be offered starting{' '}
                          {moment(this.state.startDate).format('MMM DD')}.
                          {this.state.endDate && (
                            <span>
                              {' '}
                              After {moment(this.state.endDate).format('MMM DD')}, we
                              will not respond to any customers
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="input-container">
                        <div className="title-header">
                          <span className="material-icons">message</span>
                          <div className="title">Pricing Response</div>
                          <div className="divider"></div>
                        </div>
                        <label className="label">
                          How would you like the AI to respond to questions about pricing for this promotion?
                        </label>
                        <TextareaCounter
                          rows="3"
                          name="campaign_message"
                          value={this.state.pricing_message}
                          onChange={(e) => this.handleChange(e, 'pricing_message')}
                          maxLength={160}
                          className="text"
                        />
                        <div className="disclaimer">
                          *We recommend including pricing info specific to the offer and a link to standard post-promo pricing
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="message">
                    <div className="title">Messages</div>
                    <div className="form-container">
                      <div className="input-container">
                        <label className="label">
                          How many times would you like TrueLark to try to engage your lead?
                        </label>
                        <div className="select-container">
                          {reminder_counts.map((follow_up_value) => {
                            return (
                              <div className="radio-group">
                                <input type="radio"
                                  name={follow_up_value.key}
                                  value={follow_up_value.key}
                                  checked={follow_up_value.value == follow_up_count}
                                  onChange={(e) => this.handleChange(e, 'follow_up_count')}
                                  disabled={editmode}
                                  className={classnames({ 'disabled-input': editmode })}
                                />
                                <label className="radio-label" for={follow_up_value.key}>{follow_up_value.key + 1}</label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="input-container">
                        <div className="title-header">
                          <span className="material-icons">message</span>
                          <div className="title">First Message</div>
                          <div className="divider"></div>
                        </div>
                        <label className="label">
                          What would you like the first text message from TrueLark?
                        </label>
                        <TextareaCounter
                          rows="3"
                          name="campaign_message"
                          value={this.state.first_message}
                          onChange={(e) => this.handleChange(e, 'first_message')}
                          maxLength={160}
                          className="text"
                        />
                      </div>
                      {follow_ups.map(follow => {
                        return (
                          <>
                            <div className="input-container">
                              <div className="title-header">
                                <span className="material-icons">message</span>
                                <div className="title">Follow-up {follow.follow_up_index}</div>
                                <div className="divider"></div>
                              </div>
                              <label className="label">
                                What would you like the {this.stringifyNumber(follow.follow_up_index + 1)} text message from TrueLark to say?
                              </label>
                              <TextareaCounter
                                rows="3"
                                name="campaign_message"
                                value={follow.message}
                                onChange={(e) => this.handleFollowUp(e, 'message', follow.follow_up_index)}
                                maxLength={160}
                                className="text"
                              />
                            </div>
                            <div className="input-container">
                              <label className="label">
                                When would you like TrueLark to send this follow-up?
                              </label>
                              <div className="select-container">
                                <select onChange={(e) => this.handleFollowUp(e, 'interval', follow.follow_up_index)} value={follow.interval_days} disabled={editmode} className={classnames({ 'disabled-input': editmode })}>
                                  {this.getMessageReminder(follow.follow_up_index).map((source) => {
                                    return (
                                      <option value={source.interval_days}>{source.value}</option>
                                    );
                                  })}
                                </select>
                                <i className="material-icons">arrow_drop_down</i>
                              </div>
                            </div>
                          </>
                        )
                      })}

                    </div>
                    <div className="actions-mobile show-in-mobile">
                      <button disabled={this.sendAbled()}
                        className="send" style={{ opacity: (this.sendAbled() ? 0.5 : 1) }}
                        onClick={this.addCampaign}> {editmode ? 'UPDATE' : 'Publish'}</button>
                    </div>
                  </div>

                </div>
              </div>
            }
            {features && !features.includes('CONTACT_INFO_HIDDEN') && 
            <div className="help-form">Reach us at support@truelark.com or call +1-408-582-7010</div>
            }
          </div>
        }
        {goBackWithoutSave &&
          <Modal
            isOpen={true}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            className="Create-Modal mobile-only"
            overlayClassName="Overlay"
            contentLabel="Example Modal"
          >
            <div>
              <div className="modal-header">
                <div className="title">Are you sure?</div>
                <button className="modal-close" onClick={this.closeModal}>
                  X
                </button>
                <div className="description">
                  if you leave this page all progress will be lost
                </div>
                <div className="actions">

                  <button
                    className="btn btn--primary btn--lg"
                    onClick={() => this.props.history.goBack()}
                  >
                    YES, CONTINUE
                  </button>
                  <button
                    className="btn btn--secondary btn--lg"
                    onClick={this.closeModal}
                  >
                    Stay on this page
                  </button>
                </div>
              </div>
            </div>
            {this.props.children}
          </Modal>
        }

      </div>
    );
  }
}
export default AddCampaign;
